import Hero from "../components/Hero";
import HeroSkeleton from "../components/HeroSkeleton";
import TrustedBy from "../components/TrustedBy";
import StatsQuote from "../components/StatsQuote";
import StudentJourney from "../components/StudentJourney";
import SkillGap from "../components/SkillGap";
import Programmes from "../components/Programmes";
import Testimonials from "../components/Testimonials";
import Mentors from "../components/Mentors";
import NextStepCTA from "../components/NextStepCTA";
// import ReadinessQuiz from "../components/ReadinessQuiz";
import WaitlistCTA from "../components/WaitlistCTA";
import { useGeo } from "../hooks/useGeo";
import { getHeroContent } from "../data/home-data";

export default function HomePage() {
    const { country, loading } = useGeo();
    const heroData = getHeroContent(country);

    return (
        <main data-testid="home-page">
            {loading ? <HeroSkeleton /> : <Hero heroData={heroData} />}
            <TrustedBy />
            <StatsQuote />
            <Programmes />
            {/* <StudentJourney /> */}
            <SkillGap />

            {/* <Testimonials /> */}
            <Mentors />
            <NextStepCTA />
            {/* <ReadinessQuiz /> */}
            {/* <WaitlistCTA /> */}
        </main>
    );
}
